import { CongSetting, CongSettings } from "../../../types/scheduling/settings";
import { useTranslation } from "react-i18next";
import { CheckBox, DDMstrings } from "./settings";

export const SettingsPW = (props: { settings: CongSettings; setSettings: (set: CongSettings) => void }) => {
  const { t } = useTranslation();
  return (
    <div>
      <CheckBox
        switchType
        settingKey={CongSetting.PWEnableOpenScheduling}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.PWEveryoneScheduleAnyone}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <DDMstrings
        settings={props.settings}
        setSettings={props.setSettings}
        settingKey={CongSetting.PWPairingBehavior}
        options={[
          { label: t("schedules.public-witnessing.gender-family"), value: "sex" },
          { label: t("schedules.fill.all"), value: "any" },
        ]}
        infoMsg={t("schedules.public-witnessing.auto-fill-behavior-info")}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.PWMyAvailability}
        settings={props.settings}
        setSettings={props.setSettings}
      />
    </div>
  );
};
